<div>
    <div class="seat-panel-component" [class.disabled-events]="loadingAddCart || loadingReserve">
        <div class="container-spinner" *ngIf="loadingAddCart || loadingReserve">
            <mat-progress-spinner color="accent" mode="indeterminate" diameter="50">
            </mat-progress-spinner>
        </div>
        <!-- Banner modo reserva eliminado: se muestra en el panel lateral de reserva -->
        <div class="content-map-select">
            <!-- Fila 1: título + botones de acción -->
            <div class="map-header-row">
                <p class="map-event-title">{{ singleSeatPass ? singleSeatPass.name : event?.title }}</p>
                <div class="map-header-actions">
                    <button *ngIf="isEventMap && loadedMap && !singleSeatPass" class="btn-header-action btn-header-action--text"
                        [class.btn-header-action--active]="massSelectionMode"
                        [disabled]="loadingMassCart && !massSelectionMode"
                        (mousedown)="$event.preventDefault()"
                        (click)="toggleMassSelection('force-exit')"
                        [title]="massSelectionMode ? 'Salir de selección masiva' : 'Activar selección masiva'"
                        tabindex="-1" #btnMassSelect>
                        <i class="fa-regular fa-objects-column"></i>
                        <span>{{ massSelectionMode ? 'Salir' : 'Selección masiva' }}</span>
                    </button>
                    <button *ngIf="event?.map_version && !singleSeatPass" class="btn-header-action" [class.btn-header-action--active]="savedCode"
                        (click)="savedCode ? deleteCode() : openUnlockDialog()"
                        [title]="savedCode ? 'Cerrar bloqueos' : 'Desbloquear asientos'">
                        <i class="fa-light" [class.fa-lock-open]="savedCode" [class.fa-lock]="!savedCode"></i>
                    </button>
                </div>
            </div>
            <!-- Fila 2: selectores de sesión (solo si hay más de una opción) -->
            <div class="map-session-row" *ngIf="!singleSeatPass && ((fechasEvent && fechasEvent?.length > 1) || optionsHours?.length > 1)">
                <div class="session-dropdown-backdrop"
                     *ngIf="dateDropdownOpen || hourDropdownOpen"
                     (click)="dateDropdownOpen = false; hourDropdownOpen = false"></div>
                <div class="select-wrapper" *ngIf="fechasEvent && fechasEvent?.length > 1">
                    <i class="fa-regular fa-calendar-days select-icon"></i>
                    <button class="session-select" (click)="dateDropdownOpen = !dateDropdownOpen; hourDropdownOpen = false">
                        <span>{{ formatDateFront(dateSelect) | date:'dd MMM yyyy':'+0000' }}{{ optionsHours?.length === 1 ? ' · ' + optionsHours[0].time + 'h' : '' }}</span>
                    </button>
                    <i class="fa-regular fa-chevron-down select-chevron" [class.select-chevron--open]="dateDropdownOpen"></i>
                    <div class="session-options-panel" *ngIf="dateDropdownOpen">
                        <button class="session-option" *ngFor="let fecha of fechas"
                                [class.session-option--active]="fecha === dateSelect"
                                (click)="selectDate(fecha)">
                            {{ formatDateFront(fecha) | date:'dd MMM yyyy':'+0000' }}{{ optionsHours?.length === 1 ? ' · ' + optionsHours[0].time + 'h' : '' }}
                        </button>
                    </div>
                </div>
                <div class="select-wrapper" *ngIf="optionsHours?.length > 1">
                    <i class="fa-regular fa-clock select-icon"></i>
                    <button class="session-select" (click)="hourDropdownOpen = !hourDropdownOpen; dateDropdownOpen = false">
                        <span>{{ hourSelected?.time }}h</span>
                    </button>
                    <i class="fa-regular fa-chevron-down select-chevron" [class.select-chevron--open]="hourDropdownOpen"></i>
                    <div class="session-options-panel" *ngIf="hourDropdownOpen">
                        <button class="session-option" *ngFor="let hour of optionsHours"
                                [class.session-option--active]="hour?.time === hourSelected?.time"
                                [class.session-option--disabled]="isHourDisabled(hour)"
                                (click)="selectHour(hour)">
                            {{ hour.time }}h
                        </button>
                    </div>
                </div>
            </div>
            <div class="map-capacity-row" *ngIf="loadedMap && enabled != null && (event?.capacity || event?.space?.capacity) && !massSelectionMode">
                <span class="available-badge">
                    <i class="fa-regular fa-loveseat"></i> {{(event?.capacity || event?.space?.capacity) - (enabled >= 0 ? enabled : 0)}} ocupados de {{event?.capacity || event?.space?.capacity}}
                </span>
            </div>
            <div class="mass-selection-toolbar d-flex align-items-center gap-2 flex-wrap" *ngIf="loadedMap && massSelectionMode">
                <div class="d-flex align-items-center gap-3 ms-2 flex-wrap mass-toolbar-group">
                    <!-- Grupo: Pan del mapa -->
                    <div class="btn-group-pan d-flex align-items-center pe-2 border-end">
                        <button class="btn-selection-mode" [class.active]="buttonPanMode"
                            (click)="toggleButtonPanMode()" title="Mover el mapa">
                            <i class="fa-regular fa-arrows-up-down-left-right"></i>
                        </button>
                    </div>
                    <!-- Grupo: Modo de selección -->
                    <div class="btn-group-mode d-flex align-items-center gap-1 pe-2 border-end">
                        <button class="btn-selection-mode" [class.active]="!rectSelectionMode"
                            (click)="activateLassoMode()" title="Modo lazo libre: dibuja una zona irregular para seleccionar asientos">
                            <i class="fa-regular fa-lasso"></i>
                        </button>
                        <button class="btn-selection-mode" [class.active]="rectSelectionMode"
                            (click)="activateRectMode()" title="Modo rectángulo: dibuja un área rectangular para seleccionar asientos">
                            <i class="fa-regular fa-vector-square"></i>
                        </button>
                    </div>
                    <!-- Grupo: Acción sobre la selección -->
                    <div class="btn-group-action d-flex align-items-center gap-1 pe-2 border-end">
                        <button class="btn-selection-mode" [class.active]="selectionModeType === 'new'"
                            (click)="selectionModeType = 'new'" title="Nueva selección: reemplaza la selección anterior por la nueva">
                            <i class="fa-regular fa-mouse-pointer"></i>
                        </button>
                        <button class="btn-selection-mode" [class.active]="selectionModeType === 'add'"
                            (click)="selectionModeType = 'add'" title="Añadir: suma los asientos seleccionados a la selección actual">
                            <i class="fa-regular fa-plus"></i>
                        </button>
                        <button class="btn-selection-mode" [class.active]="selectionModeType === 'subtract'"
                            (click)="selectionModeType = 'subtract'" title="Restar: elimina los asientos seleccionados de la selección actual">
                            <i class="fa-regular fa-minus"></i>
                        </button>
                    </div>
                    <!-- Grupo: Estado y limpiar -->
                    <div class="d-flex align-items-center gap-2">
                        <span class="mass-count-badge" *ngIf="massSelectedSeats.length > 0">
                            <i class="fa-regular fa-loveseat"></i> {{massSelectedSeats.length}}
                        </span>
                        <button class="btn-clear-selection" *ngIf="massSelectedSeats.length > 0"
                            (click)="clearMassSelection()" title="Limpiar la selección masiva de asientos">
                            <i class="fa-regular fa-trash-can"></i>
                        </button>
                    </div>
                </div>
            </div>
            <hr class="map-divider">
            <div *ngIf="isEventMap; else noMap">
                <div class="w-100  justify-content-center align-items-center d-flex" style="height: 400px;"
                    *ngIf="!loadedMap; else mapLoaded">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <ng-template #mapLoaded>
                    <div class="buttons-zoom-map">
                        <button (click)="zoomMap(true)" title="Acercar mapa">
                            <i class="fa-regular fa-magnifying-glass-plus"></i>
                        </button>
                        <button (click)="zoomMap(false)" title="Alejar mapa">
                            <i class="fa-regular fa-magnifying-glass-minus"></i>
                        </button>
                    </div>
                    <div class="legend-map" style="display: none;">
                        <div class="d-flex align-items-center justify-content-between item-legend">
                            <p class="name-legend">Disponibles: </p>
                            <div class="name-legend">{{enabled}}</div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between item-legend">
                            <p class="name-legend">No disponibles: </p>
                            <div class="color-legend" [style.background]="colorDefaultHidden"></div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between item-legend">
                            <p class="name-legend">Seleccionadas: </p>
                            <div class="color-legend" [style.background]="colorDefaultSelect"></div>
                        </div>
                    </div>
                </ng-template>
                <div class="canvas-wrapper" [style.visibility]="loadedMap && !mapFitted ? 'hidden' : null">
                    <div class="canvas-loading-overlay" *ngIf="loadingMassCart && loadedMap">
                        <mat-progress-spinner color="accent" mode="indeterminate" diameter="40"></mat-progress-spinner>
                        <p>{{reservationId ? 'Añadiendo a la reserva...' : 'Añadiendo al carrito...'}}</p>
                    </div>
                    <canvas [hidden]="!loadedMap" id="myCanvas"></canvas>
                    <!-- Tooltip: pedido/reserva al que pertenece una butaca ocupada (al hacer hover) -->
                    <div class="seat-order-tooltip" *ngIf="seatOrderTooltip.visible && seatOrderTooltip.data"
                        [style.left.px]="seatOrderTooltip.x + 14" [style.top.px]="seatOrderTooltip.y + 14">
                        <p class="seat-order-tooltip__title m-0">
                            {{ seatOrderTitle(seatOrderTooltip.data) }}
                        </p>
                        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderTooltip.data.buyer_name">
                            <i class="fa-light fa-user"></i> {{ seatOrderTooltip.data.buyer_name }}
                        </p>
                        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderTooltip.data.created_at">
                            <i class="fa-light fa-calendar"></i>
                            {{ seatOrderTooltip.data.created_at | date:'dd/MM/yyyy - HH:mm' }}
                        </p>
                        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderChannelLabel(seatOrderTooltip.data)">
                            <i class="fa-light fa-store"></i> {{ seatOrderChannelLabel(seatOrderTooltip.data) }}
                        </p>
                        <p class="seat-order-tooltip__row m-0" *ngIf="seatOrderStatusLabel(seatOrderTooltip.data)">
                            <i class="fas fa-circle" [style.color]="seatOrderStatusColor(seatOrderTooltip.data)"
                                style="font-size: 8px;"></i>
                            <span [style.color]="seatOrderStatusColor(seatOrderTooltip.data)">{{ seatOrderStatusLabel(seatOrderTooltip.data) }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <ng-template #noMap>
                <div class="no-map-wrapper">

                    <!-- Header con aforo -->
                    <div class="no-map-head" *ngIf="(event?.capacity || event?.space?.capacity) && enabled !== null">
                        <div class="no-map-head-text">
                            <p class="no-map-head-title">{{ eventSoldOut || enabled <= 0 ? 'Agotado' : 'Entradas disponibles' }}</p>
                            <p class="no-map-head-sub" *ngIf="!eventSoldOut && enabled > 0">
                                Quedan {{ enabled }} de {{ event?.capacity || event?.space?.capacity }}
                            </p>
                        </div>
                        <div class="capacity-progress" *ngIf="!eventSoldOut && enabled > 0">
                            <div class="capacity-progress-bar"
                                 [style.width.%]="(enabled / (event?.capacity || event?.space?.capacity)) * 100"></div>
                        </div>
                    </div>

                    <!-- Lista compacta de tipos de entrada -->
                    <div class="no-map-tickets">
                        <p class="no-map-section-title">Tipos de entrada</p>

                        <div class="ticket-row-list">
                            <div *ngFor="let ticket of ticketOptionsNoMap"
                                class="ticket-row"
                                [class.ticket-row--active]="ticket.id === ticketOptionSelectedNoMap?.id"
                                (click)="changeSelectTicketNoMap(ticket)">
                                <div class="ticket-row-radio"></div>
                                <div class="ticket-row-info">
                                    <span class="ticket-row-name">{{ ticket.name }}</span>
                                </div>
                                <span class="ticket-row-price">{{ ticket.price | number:'1.2-2' }} €</span>
                            </div>
                        </div>
                    </div>

                    <!-- Footer pegajoso con stepper + total + CTA -->
                    <div class="no-map-footer" *ngIf="ticketOptionSelectedNoMap">
                        <div class="footer-row">
                            <div class="footer-summary">
                                <span class="summary-name">{{ ticketOptionSelectedNoMap.name }}</span>
                                <span class="summary-unit-price">{{ ticketOptionSelectedNoMap.price | number:'1.2-2' }} € / ud</span>
                            </div>
                            <div class="qty-stepper">
                                <button class="qty-btn" (click)="decrementTicketQty()"
                                    [disabled]="ticketQty <= 1 || eventSoldOut || enabled <= 0">
                                    <fa-icon [icon]="faMinus"></fa-icon>
                                </button>
                                <input class="qty-input" type="number" min="1" [max]="enabled"
                                    [(ngModel)]="ticketQty" (ngModelChange)="onTicketQtyInput()"
                                    [disabled]="eventSoldOut || enabled <= 0" />
                                <button class="qty-btn" (click)="incrementTicketQty()"
                                    [disabled]="ticketQty >= enabled || eventSoldOut || enabled <= 0">
                                    <fa-icon [icon]="faPlus"></fa-icon>
                                </button>
                            </div>
                        </div>
                        <button class="no-map-cta no-map-cta--cart" *ngIf="!reservationMode"
                            (click)="addToCart(ticketOptionSelectedNoMap, +ticketQty)"
                            [disabled]="eventSoldOut || enabled <= 0 || (event.maxTikets && eventLimitActual >= event.maxTikets)">
                            <i class="fa-regular fa-cart-plus"></i>
                            <span>{{ eventSoldOut || enabled <= 0 ? 'Agotado' : 'Añadir' }}</span>
                            <span class="cta-total" *ngIf="!eventSoldOut && enabled > 0">
                                {{ (ticketOptionSelectedNoMap.price * ticketQty) | number:'1.2-2' }} €
                            </span>
                        </button>
                        <button class="no-map-cta no-map-cta--reserve" *ngIf="reservationMode"
                            (click)="addToReservation(ticketOptionSelectedNoMap)"
                            [disabled]="eventSoldOut || enabled <= 0 || (event.maxTikets && eventLimitActual >= event.maxTikets) || loadingReserve">
                            <i class="fa-regular fa-bookmark" *ngIf="!loadingReserve"></i>
                            <span>{{ eventSoldOut || enabled <= 0 ? 'Agotado' : (loadingReserve ? 'Reservando...' : 'Añadir a reserva') }}</span>
                            <span class="cta-total" *ngIf="!eventSoldOut && enabled > 0 && !loadingReserve">
                                {{ (ticketOptionSelectedNoMap.price * ticketQty) | number:'1.2-2' }} €
                            </span>
                        </button>
                    </div>

                </div>
            </ng-template>
            <div class="actived-seat" style="border-radius: 24px;" *ngIf="activedSeat && !singleSeatPass">
                <div class="d-flex justify-content-between">
                    <div>
                        <p class="name-section m-0" style="font-weight: 600;">{{levelSelected?.name}}</p>
                        <p style="color: #7A7A7A; font-size: 14px; margin-top: 8px;">
                            <i class="fa-thin fa-loveseat" style="padding-right: 8px;"></i>
                            <span>{{activedSeat.section.name}}</span>
                            <span> | </span>
                            <span>Fila: {{activedSeat.row}} </span>
                            <span> | </span>
                            <span>Butaca:
                                {{activedSeat.seat}} </span>
                        </p>
                    </div>
                    <i class="btn-close-map fa-regular fa-times" style="cursor: pointer;" (click)="closeActived()"></i>
                </div>
                <div class="options-price">
                    <div class="d-flex" *ngIf="checkInvite">
                        <i class="fa-light fa-circle-check icon-invite"></i>
                        <p class="m-0 info-invite">Todas las entradas cuentan con un descuento del 100%.</p>
                    </div>
                    <div *ngIf="!optionSection || (optionSection.length <= 0 && !passMode)">
                        <p>Cargando...</p>
                    </div>
                    <div *ngIf="passMode && optionSection?.length === 0">
                        <p>Esta butaca no tiene entradas válidas para el abono.</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between type-ticket"
                        style="border-top: 1px solid #d2d2d2; padding-top: 8px;" *ngFor="let option of optionSection; let i = index">
                        <div class="d-flex">
                            <span>{{option.name}}</span>
                            <span style="margin-left: 6px; margin-right: 6px;">|</span>
                            <span style="font-weight: 600;">{{option.price | number:'1.2-2'}} €</span>
                        </div>
                        <!-- Botón Añadir al carrito (modo venta normal) -->
                        <div class="w-100 primary-button solid btn-select-ticket btn-primary"
                            *ngIf="!reservationMode"
                            [class.disabled-loading]="loadingAddCart"
                            style="cursor: pointer; border-radius: 24px;" (click)="addTicket(option)">
                            <i class="fa-regular fa-cart-plus"></i>
                        </div>
                        <!-- Botón Reservar (modo reserva) -->
                        <div class="w-100 primary-button solid btn-select-ticket btn-reserve"
                            *ngIf="reservationMode"
                            [class.disabled-loading]="loadingReserve"
                            style="cursor: pointer; border-radius: 24px;" (click)="reserveTicket(option)"
                            title="Añadir a reserva">
                            <i class="fa-regular fa-bookmark"></i>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Mass selection add-to-cart panel -->
            <div class="actived-seat" style="border-radius: 24px;"
                *ngIf="massSelectionMode && massSelectedSeats.length > 0">
                <div class="d-flex justify-content-between">
                    <div>
                        <p class="name-section m-0" style="font-weight: 600;">
                            {{massSelectedSeats.length}} asiento(s) seleccionado(s)
                        </p>
                        <p style="color: #7A7A7A; font-size: 14px; margin-top: 8px;">
                            <i class="fa-thin fa-loveseat" style="padding-right: 8px;"></i>
                            <span>Selecciona el tipo de entrada para añadirlas todas</span>
                        </p>
                    </div>
                    <i class="btn-close-map fa-regular fa-times" style="cursor: pointer;"
                        (click)="clearMassSelection()"></i>
                </div>
                <div class="options-price">
                    <div *ngIf="!(massOptionSection.length ? massOptionSection : optionsTickets)?.length">
                        <p>Cargando...</p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between type-ticket"
                        style="border-top: 1px solid #d2d2d2; padding-top: 8px;"
                        *ngFor="let option of (massOptionSection.length ? massOptionSection : optionsTickets); let i = index">
                        <div class="d-flex">
                            <span>{{option.name}}{{option._levelName ? ' — ' + option._levelName : ''}}</span>
                            <span style="margin-left: 6px; margin-right: 6px;">|</span>
                            <span style="font-weight: 600;">{{option.price | number:'1.2-2'}} €</span>
                        </div>
                        <!-- Botón Añadir al carrito (modo venta normal) -->
                        <div class="w-100 primary-button solid btn-select-ticket btn-primary"
                            *ngIf="!reservationMode"
                            [class.disabled-loading]="loadingMassCart"
                            style="cursor: pointer; border-radius: 24px;"
                            (click)="massTicketOption = option; addMassSeatsToCart()">
                            <mat-progress-spinner *ngIf="loadingMassCart && massTicketOption?.id === option.id"
                                diameter="18" mode="indeterminate"></mat-progress-spinner>
                            <i class="fa-regular fa-cart-plus"
                                *ngIf="!(loadingMassCart && massTicketOption?.id === option.id)"></i>
                        </div>
                        <!-- Botón Reservar (modo reserva) -->
                        <div class="w-100 primary-button solid btn-select-ticket btn-reserve"
                            *ngIf="reservationMode"
                            [class.disabled-loading]="loadingMassCart"
                            style="cursor: pointer; border-radius: 24px;"
                            (click)="massTicketOption = option; addMassSeatsToCart()"
                            title="Añadir a reserva">
                            <mat-progress-spinner *ngIf="loadingMassCart && massTicketOption?.id === option.id"
                                diameter="18" mode="indeterminate"></mat-progress-spinner>
                            <i class="fa-regular fa-bookmark"
                                *ngIf="!(loadingMassCart && massTicketOption?.id === option.id)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>